import { render } from "./post-list.vue?vue&type=template&id=86246fc4&scoped=true"
import script from "./post-list.vue?vue&type=script&lang=js"
export * from "./post-list.vue?vue&type=script&lang=js"

import "./post-list.vue?vue&type=style&index=0&id=86246fc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86246fc4"]])

export default __exports__